import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_videoPlayer/$series/")({
  component: () => <Outlet />,
  beforeLoad: ({ params }) => {
    return redirect({
      to: "/$series/$episode",
      params: {
        series: params.series,
        episode: "0",
      },
    });
  },
});
